import { transcriptParagraphs } from '@src/utility/transcriptSnippet';
import styled from 'styled-components';

import { TooltipContainer } from './ClipContextTooltip';

/**
 * The transcript-overview hover panel: a capped, non-scrolling excerpt of a
 * clip's transcript, one block per paragraph (a reel's sections arrive joined
 * by blank lines and read as separate blocks). Shares ClipContextTooltip's
 * container chrome, so it belongs to the same DARK_TOOLTIP_STYLE rich-hover
 * family. Tooltip-agnostic on purpose — the clip preview modal can embed it
 * directly later.
 */
export function TranscriptExcerptPanel({
  text,
  title,
}: {
  text: string;
  title?: string;
}) {
  const paragraphs = transcriptParagraphs(text);
  if (paragraphs.length === 0) return null;
  return (
    <TooltipContainer $fixed>
      {title && <PanelTitle>{title}</PanelTitle>}
      {paragraphs.map((paragraph, index) => (
        <Paragraph key={index}>{paragraph}</Paragraph>
      ))}
    </TooltipContainer>
  );
}

const PanelTitle = styled.div`
  font-size: var(--text-xs);
  font-weight: var(--font-weight-bold);
  color: var(--text-muted);
  padding-bottom: var(--spacing-2xs);
  border-bottom: 1px solid var(--border);
`;

/* Reading typography (PARAGRAPH_TOOLTIP_STYLE's rationale): normal weight,
   1.5 leading, left-aligned. Block separation comes from the container's gap. */
const Paragraph = styled.div`
  font-size: var(--text-xs);
  font-weight: var(--font-weight-normal);
  line-height: 1.5;
  color: var(--foreground);
`;
